/*
 * addon-upsell.js
 * When a shopper presses Add to cart without picking any SellMore add-on, offer the
 * add-ons in a small prompt with a quick "+" on each. Works on the product page and
 * inside the quick-add modal (where the SellMore script is not loaded), so it reads the
 * add-on rows SellMore renders ([data-pt-addons]) and does its own bundled /cart/add.
 */
(function () {
  if (window.ptAddonUpsellLoaded) return;
  window.ptAddonUpsellLoaded = true;

  var SKIP_FLAG = 'ptUpsellSkip';
  var openDialog = null;

  // Same size matching SellMore uses so a 15" laptop is offered the 15" sleeve.
  function extractSizeInches(text) {
    if (!text) return null;
    var match = text.match(/(\d+(?:\.\d+)?)[\s-]*(?:"|″|”|inch(?:es)?\b|in\.?\b)(?!\s*\d)/i);
    if (!match) return null;
    var value = parseFloat(match[1]);
    return isNaN(value) ? null : value;
  }

  function extractOptionSize(text) {
    var size = extractSizeInches(text);
    if (size != null) return size;
    if (!text) return null;
    var match = text.match(/^\s*(\d+(?:\.\d+)?)\s*(?:$|[\s\/,-])/);
    return match ? parseFloat(match[1]) : null;
  }

  function pickSizeMatch(options, targetSize) {
    var candidates = [];
    options.forEach(function (opt) {
      if (opt.disabled) return;
      var size = extractOptionSize(opt.text);
      if (size != null) candidates.push({ size: size, option: opt });
    });
    if (!candidates.length) return null;

    var exact = candidates.filter(function (c) { return Math.abs(c.size - targetSize) < 0.05; });
    if (exact.length) return exact[0].option;

    var larger = candidates.filter(function (c) { return c.size > targetSize; });
    if (larger.length) {
      larger.sort(function (a, b) { return a.size - b.size; });
      return larger[0].option;
    }
    return candidates.sort(function (a, b) { return b.size - a.size; })[0].option;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function readAddons(widget) {
    var targetSize = extractSizeInches(widget.getAttribute('data-main-title'));
    var addons = [];

    widget.querySelectorAll('[data-pt-addon]').forEach(function (row) {
      var titleEl = row.querySelector('.pt-addon__title');
      var priceEl = row.querySelector('[data-pt-addon-price]');
      var imgEl = row.querySelector('img');
      var select = row.querySelector('[data-pt-addon-variant-select]');

      var addon = {
        title: titleEl ? titleEl.textContent.trim() : '',
        image: imgEl ? imgEl.getAttribute('src') : '',
        price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '',
        variantId: row.getAttribute('data-variant-id'),
        options: null
      };

      if (select && select.options.length > 1) {
        addon.options = Array.prototype.map.call(select.options, function (opt) {
          return { value: opt.value, text: opt.textContent.trim(), price: opt.getAttribute('data-price') || '', disabled: opt.disabled };
        });
        var match = targetSize != null ? pickSizeMatch(addon.options, targetSize) : null;
        var preferred = match || addon.options.filter(function (o) { return o.value === select.value && !o.disabled; })[0];
        var fallback = addon.options.filter(function (o) { return !o.disabled; })[0];
        var chosen = preferred || fallback;
        if (!chosen) return; // every variant sold out
        addon.variantId = chosen.value;
        addon.price = chosen.price || addon.price;
      } else if (row.classList.contains('pt-addon--soldout')) {
        return;
      }

      if (addon.variantId) addons.push(addon);
    });

    return addons;
  }

  function closeDialog(restoreFocus) {
    if (!openDialog) return;
    var dialog = openDialog;
    openDialog = null;
    document.removeEventListener('keydown', dialog.onKey, true);
    dialog.root.remove();
    document.documentElement.classList.remove('pt-upsell-open');
    if (restoreFocus !== false && dialog.opener && dialog.opener.focus) dialog.opener.focus();
  }

  function buildRow(addon, state) {
    var item = el('li', 'pt-upsell__item');

    var media = el('span', 'pt-upsell__media');
    if (addon.image) {
      var img = el('img');
      img.src = addon.image;
      img.alt = '';
      img.width = 112;
      img.height = 112;
      img.loading = 'lazy';
      media.appendChild(img);
    }
    item.appendChild(media);

    var info = el('span', 'pt-upsell__info');
    info.appendChild(el('span', 'pt-upsell__title', addon.title));

    var price = el('span', 'pt-upsell__price', addon.price);

    if (addon.options) {
      var select = el('select', 'pt-upsell__select');
      select.setAttribute('aria-label', 'Option for ' + addon.title);
      addon.options.forEach(function (opt) {
        var option = el('option', '', opt.text + (opt.disabled ? ' (sold out)' : ''));
        option.value = opt.value;
        option.disabled = opt.disabled;
        if (opt.value === addon.variantId) option.selected = true;
        select.appendChild(option);
      });
      select.addEventListener('change', function () {
        addon.variantId = select.value;
        var current = addon.options.filter(function (o) { return o.value === select.value; })[0];
        if (current && current.price) price.textContent = current.price;
      });
      info.appendChild(select);
    }
    info.appendChild(price);
    item.appendChild(info);

    var button = el('button', 'pt-upsell__add');
    button.type = 'button';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', 'Add ' + addon.title);
    button.innerHTML =
      '<svg class="pt-upsell__plus" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>' +
      '<svg class="pt-upsell__tick" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 4.5"/></svg>';
    button.addEventListener('click', function () {
      var on = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(on));
      item.classList.toggle('is-added', on);
      addon.selected = on;
      state.update();
    });
    item.appendChild(button);

    return item;
  }

  function showDialog(form, addons, submitter) {
    var root = el('div', 'pt-upsell');
    var backdrop = el('div', 'pt-upsell__backdrop');
    var panel = el('div', 'pt-upsell__panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'pt-upsell-title');
    panel.tabIndex = -1;

    var close = el('button', 'pt-upsell__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>';

    var title = el('h2', 'pt-upsell__heading', 'Add anything to your order?');
    title.id = 'pt-upsell-title';
    var sub = el('p', 'pt-upsell__sub', 'Popular with this item. Tap + to add.');
    var list = el('ul', 'pt-upsell__list');
    var error = el('p', 'pt-upsell__error');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    var confirm = el('button', 'pt-upsell__confirm');
    confirm.type = 'button';

    var state = {
      update: function () {
        var count = addons.filter(function (a) { return a.selected; }).length;
        confirm.textContent = count ? 'Add to cart (+' + count + (count === 1 ? ' extra)' : ' extras)') : 'No thanks, add to cart';
        confirm.classList.toggle('is-plain', !count);
      }
    };

    addons.forEach(function (addon) { list.appendChild(buildRow(addon, state)); });
    state.update();

    panel.appendChild(close);
    panel.appendChild(title);
    panel.appendChild(sub);
    panel.appendChild(list);
    panel.appendChild(error);
    panel.appendChild(confirm);
    root.appendChild(backdrop);
    root.appendChild(panel);
    document.body.appendChild(root);
    document.documentElement.classList.add('pt-upsell-open');

    var dialog = { root: root, opener: submitter, onKey: null };
    dialog.onKey = function (evt) {
      if (evt.key === 'Escape') {
        evt.stopPropagation();
        closeDialog();
      } else if (evt.key === 'Tab') {
        var focusable = panel.querySelectorAll('button, select');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (evt.shiftKey && document.activeElement === first) {
          evt.preventDefault();
          last.focus();
        } else if (!evt.shiftKey && document.activeElement === last) {
          evt.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', dialog.onKey, true);
    openDialog = dialog;

    backdrop.addEventListener('click', function () { closeDialog(); });
    close.addEventListener('click', function () { closeDialog(); });

    confirm.addEventListener('click', function () {
      var chosen = addons.filter(function (a) { return a.selected; });
      if (!chosen.length) {
        closeDialog(false);
        form.dataset[SKIP_FLAG] = '1';
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
        return;
      }
      addBundle(form, chosen, {
        busy: function (on) {
          confirm.disabled = on;
          if (on) confirm.textContent = 'Adding...';
        },
        error: function (message) {
          error.textContent = message;
          error.hidden = false;
          confirm.textContent = 'Try again';
        }
      });
    });

    confirm.focus();
  }

  // ui = { busy(isBusy), error(message) }
  function addBundle(form, chosen, ui) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var mainQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!mainQty || mainQty < 1) mainQty = 1;

    var mainItem = { id: Number(idInput.value), quantity: mainQty };

    var sellingPlan = form.querySelector('[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value) mainItem.selling_plan = Number(sellingPlan.value);

    var props = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      var match = input.name.match(/^properties\[(.+)\]$/);
      if (match) props[match[1]] = input.value;
    });
    if (Object.keys(props).length) mainItem.properties = props;

    var items = [mainItem];
    chosen.forEach(function (addon) {
      items.push({ id: Number(addon.variantId), quantity: 1, properties: { _pt_addon: 'product' } });
    });

    var routes = window.Shopify && window.Shopify.routes ? window.Shopify.routes : null;
    var rootUrl = routes && routes.root ? routes.root.replace(/\/$/, '') : '';
    var addUrl = (window.routes && window.routes.cart_add_url) || rootUrl + '/cart/add';
    var cartUrl = (window.routes && window.routes.cart_url) || rootUrl + '/cart';

    ui.busy(true);

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error((result.data && (result.data.description || result.data.message)) || 'Sorry, these items could not be added to your cart.');
        }
        window.location = cartUrl;
      })
      .catch(function (err) {
        ui.busy(false);
        ui.error(err && err.message ? err.message : 'Sorry, something went wrong. Please try again.');
      });
  }

  // The SellMore script marks a widget it has bound (data-pt-viewed / data-pt-bound).
  function boundBySellmore(widget) {
    return widget.hasAttribute('data-pt-viewed') || widget.hasAttribute('data-pt-bound');
  }

  // Add-ons rendered inside the quick-add popup: SellMore's script is not loaded there, so
  // give the rows their checked state, size matching and variant dropdown behaviour.
  function bindInline(widget) {
    if (widget.hasAttribute('data-pt-upsell-bound') || boundBySellmore(widget)) return;
    widget.setAttribute('data-pt-upsell-bound', 'true');

    var targetSize = extractSizeInches(widget.getAttribute('data-main-title'));

    widget.querySelectorAll('[data-pt-addon]').forEach(function (row) {
      var input = row.querySelector('.pt-addon__input');
      if (!input) return;

      var sync = function () { row.classList.toggle('is-active', input.checked); };
      input.addEventListener('change', sync);
      sync();

      var select = row.querySelector('[data-pt-addon-variant-select]');
      if (!select) return;

      var apply = function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        row.setAttribute('data-variant-id', opt.value);
        input.value = opt.value;
        var priceEl = row.querySelector('[data-pt-addon-price]');
        var price = opt.getAttribute('data-price');
        if (priceEl && price) {
          priceEl.innerHTML = opt.disabled ? price + ' <span class="pt-addon__soldout">Sold out</span>' : price;
        }
        row.classList.toggle('pt-addon--soldout', !!opt.disabled);
      };

      select.addEventListener('click', function (evt) { evt.stopPropagation(); });
      select.addEventListener('change', apply);

      if (targetSize != null) {
        var options = Array.prototype.map.call(select.options, function (o) {
          return { value: o.value, text: o.textContent, disabled: o.disabled };
        });
        var match = pickSizeMatch(options, targetSize);
        if (match) select.value = match.value;
      }
      apply();
    });
  }

  function bindAllInline() {
    document.querySelectorAll('quick-add-modal [data-pt-addons]').forEach(bindInline);
  }

  function showFormError(form, message) {
    var wrapper = form.querySelector('.product-form__error-message-wrapper');
    var text = wrapper && wrapper.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message;
    wrapper.toggleAttribute('hidden', false);
    wrapper.removeAttribute('hidden');
  }

  function formUi(form, button) {
    return {
      busy: function (on) {
        if (!button) return;
        if (on) {
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('loading');
        } else {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      },
      error: function (message) { showFormError(form, message); }
    };
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || form.tagName !== 'FORM') return;

      if (form.dataset[SKIP_FLAG]) {
        delete form.dataset[SKIP_FLAG];
        return;
      }

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      var info = form.closest('product-info');
      var widget = info && info.querySelector('[data-pt-addons]');
      if (!widget) return;

      // Shopper already ticked add-ons. If SellMore's script is bound it bundles them itself
      // (product page). In the quick-add popup it is not, so bundle them here.
      var ticked = widget.querySelectorAll('.pt-addon__input:checked');
      if (ticked.length) {
        if (boundBySellmore(widget)) return;
        var picked = Array.prototype.map.call(ticked, function (input) { return { variantId: input.value }; });
        evt.preventDefault();
        evt.stopPropagation();
        addBundle(form, picked, formUi(form, evt.submitter || form.querySelector('[type="submit"]')));
        return;
      }

      var addons = readAddons(widget);
      if (!addons.length) return;

      evt.preventDefault();
      evt.stopPropagation();
      showDialog(form, addons, evt.submitter || form.querySelector('[type="submit"]'));
    },
    true
  );

  // Quick-add popups inject the product HTML after load, so bind add-on rows as they appear.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAllInline);
  else bindAllInline();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          bindAllInline();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
